import { render, staticRenderFns } from "./DynamicFormElement.vue?vue&type=template&id=1f96126f"
import script from "./DynamicFormElement.vue?vue&type=script&lang=js"
export * from "./DynamicFormElement.vue?vue&type=script&lang=js"
import style0 from "./DynamicFormElement.vue?vue&type=style&index=0&id=1f96126f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports